<div class="claim_body">
    <div class="top_panel">
      <h3>Add Escrow Payment</h3>
      <span (click)="close()" class="close">
          <img src="https://cdn.elitehw.com/images/cross.webp" />
      </span>
    </div>
    <div class="formarea">
      <form [formGroup]="checkPaymentForm">
        <div class="inputprt">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Check Number</mat-label>
            <input matInput placeholder="Check Number"  mask="0*" formControlName="checkNumber"/>
            <mat-error
            *ngIf="checkPaymentForm.controls['checkNumber'].touched && checkPaymentForm.controls['checkNumber'].hasError('required')">
            This is required field.
        </mat-error>
        
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Amount</mat-label>
            <input matInput placeholder="Amount"  mask="separator.2" prefix="$" thousandSeparator="," formControlName="amount" />
            <mat-error
            *ngIf="checkPaymentForm.controls['amount'].touched && checkPaymentForm.controls['amount'].hasError('required')">
            This is required field.
        </mat-error>
        </mat-form-field>
        </div>
        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <button mat-button type="button" class="sub-button" (click)="handleSavePayment()"><span>Save</span></button>
          <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
        </div>
      </form>
    </div>
  </div>
  